import { Card, CardContent, Grid } from "@material-ui/core";
import React, { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import Footer from "~/components/common/footerContainer/FooterContainer";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { useTranslation } from "react-i18next";
import businessService from "~/services/businessService";
import { useRequestMonitor } from "~/hooks/useRequestMonitor";
import { useContext } from "react";
import { DialogBuilder } from "~/utils/DialogProvider";
import businessAction from "~/store/actions/businessAction";
import googleReserveService from "~/services/googleReserveService";
import userUpdateService from "~/services/userUpdateService";
import VendorCategoryServices from "~/components/vendorPage/VendorCategoryServices/VendorCategoryServices";
import Utils from "~/helpers/Utils";
import { Firebase } from "~/services/firebase";
import { mixpanelUserInitialize, mixpanelTrackEvent } from "~/utils/mixpanel";
import { captureBookingOrigin, getBookingOrigin } from "~/utils/bookingOrigin";
import SEO from "~/components/seo";
import _ from "lodash";
import couponAction from "~/store/actions/couponAction";
import languageHelper from "~/helpers/language";
import { setLanguageFromBusiness } from "~/i18n";
import i18n from "~/i18n";
import { verifyAuthCode } from "~/services/loginService";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { VendorSkeleton } from "~/components/VendorSkeleton";
import meAction from "~/store/actions/meAction";
import authAction from "~/store/actions/authAction";
import BusinessHeader from "~/components/common/businessHeader";
import ExpiredLinkModal from "~/components/common/dialog/ExpiredLinkModal";
import packagesServices from "~/services/packagesServices";
import servicePackageAction from "~/store/actions/servicePackageAction";
import { useContract } from "~/contexts/ContractContext";
import { usePolicyCancellation } from "~/contexts/PolicyCancellationContext";
import authService from "~/services/authService";

const VendorPage = (props) => {
	const dispatch = useDispatch();
	const { id, bookingTransactionId, token, code } = useParams();
	const { user } = useSelector((store) => store.auth);
	const { me: meStoreFromStore } = useSelector((store) => store.me);
	const { business: businessStore } = useSelector((store) => store.business);
	const [business, setBusiness] = useState(null);
	const dialog = useContext(DialogBuilder);
	const { t } = useTranslation();
	const { monitorRequest } = useRequestMonitor();
	const { loadContract } = useContract();
	const { loadPolicyCancellation } = usePolicyCancellation();
	const isCodeLoginInProgressRef = useRef(false);

	const meStore = Utils.safeParseJSON("@prit-web/meData", meStoreFromStore);
	const [loading, setLoading] = useState(true);

	const [readyCategories, setReadyCategories] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(false);
	const [quantityCategories, setQuantityCategories] = useState(0);
	
	const [skeletonVisible, setSkeletonVisible] = useState(true);
	const [contentVisible, setContentVisible] = useState(false);
	const [showVendorDescription, setShowVendorDescription] = useState(false);

	const [showFullAddress, setShowFullAddress] = useState(false);
	const textDivRef = useRef(null);
	const [textDivHeight, setTextDivHeight] = useState(0);
	const [showExpiredLinkModal, setShowExpiredLinkModal] = useState(false);
	const [expiredLinkData, setExpiredLinkData] = useState(null);
	const [packages, setPackages] = useState([]);
	const [shouldResetImage, setShouldResetImage] = useState(false);
	const auth = getAuth();

	const backgroundDefault = () => {
		const verify = business?.photos[0]?.url ? business?.photos[0]?.url : 
		business?.categories?.length === 1 ? business?.categories[0]?.image : false || false;
		return verify;
	}

	const isOldBusiness = () => {
		if (!business?.createdAt) return false;
		const businessCreatedAt = new Date(business?.createdAt);
		const cutoffDate = new Date('2025-07-07');
		return businessCreatedAt < cutoffDate;
	};

	const isOld = isOldBusiness();

	const coupon = props?.location?.state?.coupon;

	const isFromOldShortener =
	(document.referrer.includes("b.prit.app/") || document.referrer.includes("link.dev.prit.app/")) &&
	!document.referrer.includes("/business/");

	const getLinkBusiness = () => {
		if (isFromOldShortener) return "Link_Endereco_Antigo";

		return "Link_Endereco_Novo";
	}

	useEffect(() => {
		localStorage.removeItem("hideAppDownloadBar");
	}, []);

	const getCustomToken = useCallback(
		async (authCode) => {
			if (!authCode || isCodeLoginInProgressRef.current) return;

			isCodeLoginInProgressRef.current = true;
			window.__PRIT_CODE_LOGIN_IN_PROGRESS__ = true;

			try {
				await authService.waitForAuthIdle();

				const result = await verifyAuthCode(authCode);

				if (result?.data?.status !== "OK" || !result?.data?.message) return;

				const customToken = result.data.message;
				const userCredential = await signInWithCustomToken(auth, customToken);
				const firebaseUser = userCredential?.user;

				if (!firebaseUser) return;

				const idToken = await firebaseUser.getIdToken();
				dispatch(authAction.setUser(firebaseUser));
				dispatch(meAction.setMe(idToken));
				localStorage.setItem("@prit-web/accessToken", idToken);
				localStorage.setItem("@prit-web/accessTokenExpirationTime", String(Date.now() + 3600000));
				dispatch(businessAction.getBusiness(id));
			} catch (error) {
				console.log("getCustomToken error:", error);
			} finally {
				isCodeLoginInProgressRef.current = false;
				window.__PRIT_CODE_LOGIN_IN_PROGRESS__ = false;
			}
		},
		[auth, dispatch, id]
	);

	useEffect(() => {
		if (code) {
			getCustomToken(code);
		}
	}, [code, getCustomToken]);

	const goToExpiredLink = (newLink, businessName) => {
		setExpiredLinkData({
			newLink: newLink,
			businessName: businessName || "Estabelecimento"
		});
		setShowExpiredLinkModal(true);
	}

	useEffect(() => {
		if (textDivRef.current) {
		  setTextDivHeight(textDivRef.current.getBoundingClientRect().height);
		}
	  }, [showFullAddress]);

	useEffect(() => {
		backgroundDefault()
	}, [business]);

	useEffect(() => {
		if (business && !selectedCategory) {
			sessionStorage.removeItem("imageCategory");
			setShouldResetImage(true);
		} else if (business && selectedCategory) {
			setShouldResetImage(false);
		}
	}, [business, selectedCategory]);

	useEffect(() => {
		localStorage.setItem("@prit-web/meData", JSON.stringify(meStore));
		localStorage.setItem("@prit-web/userId", meStore?.id);
	}, [meStore]);

	const loadSectors = async (categories) => {
		try {
			const sectors = await businessService.getSectors(categories.map((item) => item.id));
			localStorage.setItem("@prit-web/sectors", JSON.stringify(sectors.data));
			setLoading(false);
		} catch (err) {
			/*dialog
				.withMessage(t("Unable to load the sectors of this establishment"))
				.withButtonText(t("Try again"))
				.withAction(() => {
					loadSectors(categories);
				})
				.show();*/
			setLoading(false);
		}
	};

	const loadBusiness = async () => {
		setLoading(true);
		await monitorRequest(
			businessService.getBusiness(id),
			dialog
		)
			.then((res) => {
				setBusiness(res.data);
				localStorage.setItem("@prit-web/business", JSON.stringify(res.data));
				sessionStorage.setItem("@prit-web/language", res.data?.language);
				
				const languageFromBusiness = setLanguageFromBusiness(res.data?.language);
				if (languageFromBusiness) {
					i18n.changeLanguage(languageFromBusiness);
				}
				dispatch(businessAction.setBusiness(res.data));
				loadContract(res.data.id);
				loadPolicyCancellation(res.data.id, res.data.language);
				if (res?.data?.categories.length === 1) {
					const category = res?.data?.categories[0];
					setSelectedCategory({ categorie: category, pet: null, coupon: null });
					
					// Salva apenas a imagem da categoria
					sessionStorage.setItem("imageCategory", JSON.stringify(category?.image));
					window.dispatchEvent(new CustomEvent('customStorageChange', {
						detail: { key: 'imageCategory', value: category?.image }
					}));
				}
				
				dispatch(servicePackageAction.loadAvailablePackages(res.data.id, res.data.language));
				
				packagesServices.packagesList(res.data.id, res.data.language).then((res) => {
					setPackages(res.data);
				});
				
				loadSectors(res.data.categories);
				setQuantityCategories(res.data.categories.length);
				let eventProps = {};
				if (!_.isEmpty(res.data?.language)) {
					eventProps = {
						Idioma: languageHelper.translate(res.data?.language),
						Tipo_Link:  getLinkBusiness(),
						Possui_categoria: res.data.categories.length > 0 ? "Selecionada" : "Não selecionada"
					};
				}
				if (!businessStore) {
					mixpanelTrackEvent("Clickou_Link_Business", { ...eventProps, Origem_De_Agendamento: getBookingOrigin() }, meStore?.me || {}, res.data || {}, true);
				}
				if (isFromOldShortener) {
					goToExpiredLink(res.data?.dynamicLink, res.data?.name);
				}
			})
			.catch((err) => {
				dialog
					.withMessage(err?.response?.data?.message)
					.withButtonText(t("Try again"))
					.withAction(() => {
						loadBusiness();
					})
					.show();
				setLoading(false);
			})
			.finally(() => {
				setTimeout(() => {
					setReadyCategories(true);
				}, 1000);
			});
	};

	const rwg_token = new URLSearchParams(props.location.search).get("rwg_token");

	captureBookingOrigin(props.location.search);

	useEffect(() => {
		const prit_qa = new URLSearchParams(props.location.search).get("prit-qa");

		if (
			prit_qa &&
			process.env.REACT_APP_FIREBASE_INTEGRATION_TESTING &&
			prit_qa === process.env.REACT_APP_FIREBASE_INTEGRATION_TESTING
		) {
			Firebase.settings.appVerificationDisabledForTesting = true;
		}

		if (rwg_token && user) {
			dispatch(googleReserveService.googleReservePost(rwg_token));
		}
	}, [dispatch, props.location.search, rwg_token, user]);

	useEffect(() => {
		if (id && user) {
			setBusiness(null); 
    		dispatch(businessAction.setBusiness(null));
			const me = Utils.safeParseJSON("@prit-web/meData");
			if (rwg_token) {
				if (!user.isAnonymous) {
					if (!me?.rwg_token || me?.rwg_token !== rwg_token) {
						userUpdateService.pachUserUpdate(localStorage.getItem("@prit-web/userId"), {
							rwg_token: rwg_token,
						});
					}
				} else {
					localStorage.setItem("@prit-web/rwg_token", rwg_token);
				}
			}

			if (bookingTransactionId) {
				props.history.push(`/reservas/${id}/bookingTransactionId/${bookingTransactionId}`);
			} else {
				loadBusiness();
				dispatch(couponAction.getCouponBusiness(id));
			}
			setTimeout(() => {
				if (meStore?.me) {
					mixpanelUserInitialize(meStore.me || {});
				} else {
					mixpanelUserInitialize(user || {});
				}
			}, 3000);
		}
	}, [user, id]);

	const footer = () => {
		return <Footer section="agendar" token={token} bussinesId={id} setLoading={(value) => setLoading(value)}/>;
	};

	const handleSkeletonFadeOutComplete = () => {
		
		setContentVisible(true);
	};

	const goToBusinessProfile = () => {
		return props.history.push(`/perfil-business/${business?.id}`);
	}

	if (!readyCategories) {
		return (
			<>
			   <VendorSkeleton 
					isVisible={skeletonVisible} 
					onFadeOutComplete={handleSkeletonFadeOutComplete}
				/>
			</>
		)
	}

	return (
		<Fragment>
			<TitleContainer 
				headerStyle={{ boxShadow: "0", padding: "0" }} 
				footer={footer()} 
				imageVisible={true} 
				backgroundNew={true} 
				showGradient={true}
				childrenStyle={{ padding: 0 }}
				style={{
					animation: contentVisible ? "fadeIn 1s ease-out" : "none",
					opacity: contentVisible ? 1 : 0
				}}
				onRedirect={() => props.history.push(`/packages/${business?.id}`, {packages: packages})}
				floatingButton={packages.length > 0}
				validateImageCategory={shouldResetImage}
			>
				<SEO business={business} />
				<BusinessHeader
					business={business}
					onSeeMoreClick={() => goToBusinessProfile()}
					containerStyle={{ padding: "10px 10px 15px 20px"}}
					avatarStyle={{ marginRight: 5 }}
				/>
				<Grid container direction="column" style={{ Maxheight: "100vh", minHeight: "25vh", background: 'transparent' }}>
						<Card
							style={{
								boxShadow: "rgb(255 255 255 / 0%) 0px 2px 1px -1px",
								background: "transparent"
							}}>
							{<CardContent style={{ padding: "0px" }}>
									<div>
										<VendorCategoryServices 
										readyCategories={readyCategories} 
										business={business} 
										coupon={coupon} 
										loadCategories={loading} 
										showFullAddress={textDivHeight} 
										isOld={isOld} 
										category={selectedCategory}
										showVendorDescription={showVendorDescription}
										setShowVendorDescription={setShowVendorDescription}	
										quantityCategories={quantityCategories}
										/>
									</div>
							</CardContent>}
						</Card>
				</Grid>
			</TitleContainer>
			
			<style>{`
				@keyframes fadeIn {
					0% {
						opacity: 0;
						transform: translateY(30px);
					}
					100% {
						opacity: 1;
						transform: translateY(0);
					}
				}
			`}</style>
			
			{/* Expired Link Modal */}
			<ExpiredLinkModal
				open={showExpiredLinkModal}
				onClose={() => setShowExpiredLinkModal(false)}
				newLink={expiredLinkData?.newLink}
				businessName={expiredLinkData?.businessName}
			/>
		</Fragment>
	);
};

export default withRouter(VendorPage);
